package com.trevorwiebe.timesheet.mileage.data.dto

import com.trevorwiebe.timesheet.mileage.domain.model.Location
import com.trevorwiebe.timesheet.mileage.domain.model.LocationType
import kotlinx.serialization.Serializable

@Serializable
data class LocationDto(
    val name: String = "",
    val city: String = "",
    val state: String = "",
    val type: String = "DELIVERY",
    val deleted: Boolean = false,
    val address: String = "",
    val latitude: Double? = null,
    val longitude: Double? = null
)

fun LocationDto.toLocation(id: String) = Location(
    id = id,
    name = name,
    city = city,
    state = state,
    type = if (type.isBlank()) LocationType.DELIVERY else LocationType.valueOf(type),
    deleted = deleted,
    address = address,
    latitude = latitude,
    longitude = longitude
)

fun Location.toLocationDto() = LocationDto(
    name = name,
    city = city,
    state = state,
    type = type.name,
    deleted = deleted,
    address = address,
    latitude = latitude,
    longitude = longitude
)
